<template lang="pug">
    PrintablePanel
      PageHeader
        | Transaction Summary Report - County Details
      .mt-3.d-flex(v-if="!printable")
        .ml-auto
          button.btn.btn-primary.mr-2(@click.prevent="downloadCsv('storesummary.csv', csvRecords)") Download CSV
          router-link.btn.btn-primary(:to="{query: {id: $route.query.id, f: $route.query.f, t: $route.query.t, print: true}}" target="_blank") Print
      .d-flex.mt-3
        div
          | Search range:
          strong &nbsp; {{ $route.query.f }}
          | &nbsp; -
          strong &nbsp; {{ $route.query.t }}
      div.mt-4
        strong County Summary
      Datatable.mt-2(
        :columns="countyColumns"
        header-class="body-3"
        header-style="font-weight: bold;"
        :entries="[countySummary]"
        :footer="false"
        :per-page="1"
      )
        template
          tr.body-3
            td {{ countySummary.stateCd }}
            td {{ countySummary.countyName }}
            td {{ parseInt(countySummary.submittingStores).toLocaleString() }}
            td {{ parseInt(countySummary.totalActivity).toLocaleString() }}
            td {{ parseInt(countySummary.totalPurchases).toLocaleString() }}
            td {{ parseInt(countySummary.totalBlocks).toLocaleString() }}
            td {{ parseFloat(countySummary.totalGramsSold).toLocaleString() }}
            td {{ parseFloat(countySummary.totalGramsBlocked).toLocaleString() }}
            td {{ countySummary.avgBoxSizeSold }}
      div.mt-4
        strong Submitting Stores Summary
      Datatable.mt-4(
        :columns="columns"
        header-class="body-3"
        header-style="font-weight: bold;"
        :per-page="10"
        :sortable="true"
        :sort-keys="sortKeys"
        :entries="results"
        @sortTable="sort"
      )
        template(slot-scope="props")
          tr.body-3
            td {{ props.entry.pharmacyName }} - {{ props.entry.pharmacyAddress1 }}
            td {{ parseInt(props.entry.totalActivity).toLocaleString() }}
            td {{ parseInt(props.entry.totalPurchases).toLocaleString() }}
            td {{ parseInt(props.entry.totalBlocks).toLocaleString() }}
            td {{ parseFloat(props.entry.totalGramsSold).toLocaleString() }}
            td {{ parseFloat(props.entry.totalGramsBlocked).toLocaleString() }}
            td {{ props.entry.avgBoxSizeSold }}
            td {{ props.entry.avgBoxSizeBlocked }}
        
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PrintablePanel from '@/components/PrintablePanel'
import Datatable from '@/components/Datatable'
import axios from '@/lib/axios'
import { globalError } from '@/lib/utils'
import { downloadCsv } from '@/lib/csv'

function getCountySummary(fipsCd, fromDate, toDate) {
  return axios()
    .post('/api/store_summary/county', { fipsCd, fromDate, toDate })
    .catch(err => globalError(err))
}
function getData(fipsCd, fromDate, toDate) {
  return axios()
    .post('/api/store_summary/submitting', { fipsCd, fromDate, toDate })
    .catch(err => globalError(err))
}
export default {
  name: 'StoreSummaryResults2',
  data() {
    return {
      countySummary: {},
      results: [],
      countyColumns: [
        'State',
        'County/Parish',
        'Submitting Stores',
        'Total Activity',
        'Total Boxes Sold',
        'Total Boxes Blocked',
        'Total Grams Sold',
        'Total Grams Blocked',
        'Avg. Box Size Sold (grams)',
      ],
      columns: [
        'Submitting Stores',
        'Total Activity',
        'Total Boxes Sold',
        'Total Boxes Blocked',
        'Total Grams Sold',
        'Total Grams Blocked',
        'Avg. Box Size<br/>Sold (grams)',
        'Avg. Box Size<br/>Blocked',
      ],
      sortKeys: [
        'pharmacyName',
        'totalActivity',
        'totalPurchases',
        'totalBlocks',
        'totalGramsSold',
        'totalGramsBlocked',
        'avgBoxSizeSold',
        'avgBoxSizeBlocked',
      ],
    }
  },
  methods: {
    sort(info) {
      this.results.sort((a, b) => {
        let aa = parseFloat(a[info.sortKey]) || a[info.sortKey]
        let bb = parseFloat(b[info.sortKey]) || b[info.sortKey]
        return aa < bb ? -1 : aa > bb ? 1 : 0
      })
      if (info.sortDir === 'desc') this.results.reverse()
    },
    downloadCsv,
  },
  computed: {
    csvRecords() {
      return this.results.map(r => {
        return {
          'Submitting Store': `${r.pharmacyName} - ${r.pharmacyAddress1}`,
          'Total Activity': r.totalActivity,
          'Total Boxes Sold': r.totalPurchases,
          'Total Boxes Blocked': r.totalBlocks,
          'Total Grams Sold': r.totalGramsSold,
          'Avg. Box Size Sold (grams)': r.avgBoxSizeSold,
          'Avg. Box Size Blocked': r.avgBoxSizeBlocked,
        }
      })
    },
  },
  async beforeRouteEnter(to, _from, next) {
    let { data: county } = await getCountySummary(
      to.query.id,
      to.query.f,
      to.query.t,
    )
    let { data: results } = await getData(to.query.id, to.query.f, to.query.t)
    scrollTo(0, 0)
    next(vm => {
      vm.countySummary = county
      vm.results = results
      if (vm.printable) vm.$nextTick(() => window.print())
    })
  },
  components: {
    Datatable,
    PageHeader,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>
.border-left {
  border-left: 2px solid #e6e6e6;
}
</style>
